import FAQSectionI18n from "@/components/landing/shared/FAQSectionI18n";
const FAQECommerceSection = () => <FAQSectionI18n translationPrefix="industryECommerce" bgClass="bg-secondary/30" />;
export default FAQECommerceSection;
